export const NAME = 'rentVerification' as const;
